@let tooltipColor = style().textColor | color;
<section [style.background-color]="style().backgroundColor | color">
  <div class="row">
    <div class="col-lg-12 col-xs-12">
      <div class="container">
        @if (data.images[0]; as image) {
          <div class="img img-0">
            <ng-container
              *ngTemplateOutlet="
                imageTemplate;
                context: {
                  image,
                  size: { dw: 282, dh: 345, mw: 96, mh: 120 },
                  index: 0,
                }
              " />
          </div>
        }
        @if (data.images[1]; as image) {
          <div class="img img-1">
            <ng-container
              *ngTemplateOutlet="
                imageTemplate;
                context: {
                  image,
                  size: { dw: 282, dh: 180, mw: 111, mh: 75 },
                  index: 1,
                }
              " />
          </div>
        }
        @if (data.images[2]; as image) {
          <div class="img img-2">
            <ng-container
              *ngTemplateOutlet="
                imageTemplate;
                context: {
                  image,
                  size: { dw: 282, dh: 345, mw: 72, mh: 90 },
                  index: 2,
                }
              " />
          </div>
        }
        @if (data.images[3]; as image) {
          <div class="img img-3">
            <ng-container
              *ngTemplateOutlet="
                imageTemplate;
                context: {
                  image,
                  size: { dw: 282, dh: 345, mw: 72, mh: 84 },
                  index: 3,
                }
              " />
          </div>
        }
        @if (data.images[4]; as image) {
          <div class="img img-4">
            <ng-container
              *ngTemplateOutlet="
                imageTemplate;
                context: {
                  image,
                  size: { dw: 180, dh: 220, mw: 80, mh: 103 },
                  index: 4,
                }
              " />
          </div>
        }
        @if (data.images[5]; as image) {
          <div class="img img-5">
            <ng-container
              *ngTemplateOutlet="
                imageTemplate;
                context: {
                  image,
                  size: { dw: 282, dh: 180, mw: 126, mh: 80 },
                  index: 5,
                }
              " />
          </div>
        }
        <div class="content">
          <app-title [titles]="[title()]" class="title" />
          @if (data.cta; as cta) {
            <app-button [label]="cta.label" [size]="'NORMAL'" [theme]="style().buttonTheme" [url]="cta.url" />
          }
        </div>
        <ng-template #imageTemplate let-image="image" let-index="index" let-size="size">
          @if (image.image; as item) {
            <app-image [image]="item" [size]="size" />
          }
          @if (image.tooltip; as tooltip) {
            <div [style.color]="tooltipColor" class="tooltip tooltip-{{ index }}">
              @if (tooltip.title; as title) {
                <span class="tooltip-title">{{ title }} / </span>
              }
              @if (tooltip.text; as text) {
                <span class="tooltip-description">{{ text }}</span>
              }
            </div>
          }
        </ng-template>
      </div>
    </div>
  </div>
</section>
